module.exports = __webpack_public_path__ + "img/icon-pickup-cost.d32b2619.svg";